<template>
  <div class="hero">
    <div class="pic" v-if="pic">
      <div>
        <div>
          <h1 v-html="title"></h1>
          <p class="bodoni-moda" v-html="eng"></p>
        </div>
      </div>
      <img :src="pic" :alt="title" class="rellax-no" data-rellax-speed="-2">
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hero{
  position: relative;
  overflow: hidden;
}
.pic{
  position: relative;
  &:before{
    content: '';
    width: 100%;
    height: 100%;
    background: module.tone(module.$black, -8);
    position: absolute;
    top: 0;
    left: 0;
    opacity: .4;
    z-index: 2;
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  > div{
    color: module.$white;
    line-height: 1;
    padding: 2.4rem module.side2x();
    padding-top: calc(4.8rem + 16rem);
    position: relative;
    z-index: 2;
    > div{
      display: inline-flex;
      align-items: flex-end;
      justify-content: flex-start;
      padding: 0 0 .24rem;
      gap: 1.6rem;
      border-bottom: module.$white 1px solid;
    }
    h1{
      font-size: 3.2rem;
      font-weight: 400;
    }
    p{
      font-size: 1.12rem;
      letter-spacing: .2rem;
    }
  }
}
.bread{
  position: absolute;
  right: module.side();
  bottom: 2rem;
  z-index: 2;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
